import { ConstantValues } from "../Constants/ConstantValues";
import { LocationActiveStatus } from "../Constants/LocationActiveStatus";
import { OrganizationModel } from "./OrganizationModel";
import { RvqLocationPreference } from "./RvqLocationPreference";

class LocationModel {
    public Id: number;
    public Status?: LocationActiveStatus;
    public Name?: string;
    public ManagedByOrganization?: OrganizationModel;

    public DisplayText: string; // For front end only

    public constructor(init?: Partial<LocationModel>) {
        Object.assign(this, init);
        this.ManagedByOrganization = new OrganizationModel(init?.ManagedByOrganization);
    }

    public static toPreference(model: LocationModel): RvqLocationPreference {
        return new RvqLocationPreference({
            DisplayName: this.getDisplayName(model),
            QuebecVaccinationRegistryId: model.Id,
            Status: model.Status,
            Name: model.Name,
            ManagedByOrganization: new OrganizationModel(model.ManagedByOrganization)
        });
    }

    public static getDisplayName(model: LocationModel): string {
        if (!model?.Name && !model?.DisplayText)
            return "";

        if (model.Id === ConstantValues.LocationUnknownId)
            return cacheStore.GetString("UnknownLabel");

        const organizationName = model.ManagedByOrganization?.Name ? ` (${model.ManagedByOrganization?.Name})` : "";
        return model.DisplayText ?? `${model.Name}${organizationName}`;
    }
}

export { LocationModel };
